export type OngoingVoucherDisplay = {
  amount: string;
  prefix: string;
  /** e.g. "US$50", "£50", "CA$50", "AU$50", "NZ$50" */
  label: string;
};

export type OngoingVoucherFromApi = {
  amount?: number | string;
  currency_prefix?: string;
  label?: string;
};

// Client-side fallback used only when available-batches does not return
// ongoing_voucher. Localizes by country so a missing API field doesn't show
// US$50 to UK/CA/AU/NZ users. Mirrors the backend voucher config.
const VOUCHER_BY_COUNTRY: Record<string, { amount: string; prefix: string }> = {
  US: { amount: '50', prefix: 'US$' },
  CA: { amount: '50', prefix: 'CA$' },
  AU: { amount: '50', prefix: 'AU$' },
  NZ: { amount: '50', prefix: 'NZ$' },
  GB: { amount: '50', prefix: '£' },
  UK: { amount: '50', prefix: '£' },
};

const DEFAULT_FALLBACK = VOUCHER_BY_COUNTRY.US;

export const getOngoingVoucherDisplay = (
  voucher?: OngoingVoucherFromApi | null,
  country?: string | null
): OngoingVoucherDisplay => {
  if (voucher?.label) {
    const amount = String(voucher.amount ?? DEFAULT_FALLBACK.amount);
    const prefix = voucher.currency_prefix ?? '';
    return {
      amount,
      prefix,
      label: voucher.label,
    };
  }

  if (voucher?.amount != null && voucher.currency_prefix) {
    const amount = String(voucher.amount);
    return {
      amount,
      prefix: voucher.currency_prefix,
      label: `${voucher.currency_prefix}${amount}`,
    };
  }

  // Offline / missing API field — localize client-side by country.
  const normalized = (country ?? '').trim().toUpperCase();
  const fallback = VOUCHER_BY_COUNTRY[normalized] ?? DEFAULT_FALLBACK;
  return {
    amount: fallback.amount,
    prefix: fallback.prefix,
    label: `${fallback.prefix}${fallback.amount}`,
  };
};
